import styled from '@tanium/react-emotion-9';

export const AnimationOverlay = styled('div', { shouldForwardProp: (p) => p !== 'width' && p !== 'height' })<{
  width: number;
  height: number;
  left?: number;
}>(({ width, height, left = 0 }) => ({
  position: 'absolute',
  overflow: 'hidden',
  width,
  height,
  top: 0,
  left,
  pointerEvents: 'none',
  '> *': {
    pointerEvents: 'auto',
  },
}));
